export default __webpack_public_path__ + "static/media/live.ddeeff18.svg";